import React from 'react';
import { AiOutlineTeam } from 'react-icons/ai';

interface CoupleTagProps {
  text: string;
}

const CoupleTag: React.FC<CoupleTagProps> = ({ text }) => {
  return (
    <div className="bg-primary-50 inline-flex items-center gap-0.5 rounded px-1">
      <AiOutlineTeam className="text-primary-text size-4" />
      <span className="text-primary-text text-4 leading-6">{text}</span>
    </div>
  );
};

export default CoupleTag;
